import { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import { Typography } from "components/atoms";
import classNames from "classnames";
import "./card.scss";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { formatToLocalDate } from "utils/functions/formatToLocalDate";
import { formatDateDuration } from "utils/functions/formatDateDuration";
import { getTimeZone } from "utils/functions/getTimeZone";

dayjs.extend(relativeTime);
dayjs.extend(isSameOrAfter);

interface IProps {
  id: any;
  index: any;
  text: string;
  type: any;
  // moveCard: any;
  onClick: any;
  cardWeek: any;
  cardDayOfWeek: any;
  cardInfo: any;
  day: any;
  theme: "light" | "dark";
}

export const Card = ({
  id,
  text,
  index,
  type,
  cardWeek,
  cardDayOfWeek,
  onClick,
  cardInfo,
  day,
  theme,
}: IProps) => {
  const ref: any = useRef(null);

  let date = formatToLocalDate(day.dateNumber,"YYYY-MM-DD");
  let current = formatToLocalDate(dayjs(),"YYYY-MM-DD");

  const [{ isDragging }, drag] = useDrag({
    type: "card",
    item: () => {
      return { cardInfo };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    canDrag: () => {
      return cardInfo.Editable === true;
    },
  });

  drag(cardInfo.Editable === true ? ref : null);
  return (
    <div
      ref={cardInfo.Editable === true ? ref : null}
      // data-handler-id={handlerId}
      className={classNames({
        "prework-tile": true,
        "diagnostic-exam": type === "Diagnostic",
        "homework-tile": type === "Homework",
        "test-segment-tile": type === "TestSegment",
        "Test-day-tile": type === "TestDay",
        "class-segment-tile":
          type === "ClassSegment" || type === "TopicFocusSegment",
        "additional-tile":
          type !== "Homework" &&
          type !== "Diagnostic" &&
          type !== "TestSegment" &&
          type !== "ClassSegment" &&
          type !== "TopicFocusSegment" &&
          type !== "TestDay" &&
          type !== "Prework",
        isPastLightTheme: dayjs(current).isAfter(date) && theme === "light",
        isPastDarkTheme: dayjs(current).isAfter(date) && theme === "dark",
      })}
      onClick={onClick}
    >
      <Typography
        variant={type === "TestSegment" ? "h8Bold" : "h9Bold"}
        styles="card-title"
        label={text}
      />
      {type === "Homework" ||
      type === "Diagnostic" ||
      type === "ClassSegment" ||
      type === "TopicFocusSegment" ||
      type === "Prework" ? (
        <>
          {type === "ClassSegment" || type === "TopicFocusSegment" ? (
            <Typography
              variant="h9Book"
              styles="card-time"
              label={`${formatToLocalDate(
                cardInfo.StartUTC,
                "h:mm A"
              )} - ${formatToLocalDate(cardInfo.EndUTC, "h:mm A")} ${getTimeZone(cardInfo.EndUTC)}`}
            />
          ) : (
            <Typography
              variant="h9Book"
              styles="card-type"
              label={type.replace(/([A-Z])/g, " $1").trim()}
            />
          )}
          {type === "Homework" ||
          type === "Diagnostic" ||
          type === "Prework" ? (
            <div className="allign-right">
              <Typography
                variant="h9Bold"
                label={
                  cardInfo.TimeEstimate === null
                    ? `0 min`
                    : `${formatDateDuration(cardInfo.TimeEstimate)}`
                }
                styles="time-text"
              />
              <Typography
                variant="h9Bold"
                label={`${cardInfo.GroupingItemsCountComplete}/${cardInfo.GroupingItemsCount} Completed`}
                styles="time-text"
              />
            </div>
          ) : null}
        </>
      ) : null}
    </div>
  );
};
